import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AumicoAppLayoutService {
    onChangeFooterEvent$ = new Subject<any>();

    changeFooter(templateRef: any) {
        this.onChangeFooterEvent$.next(templateRef);
    }
}
